var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product"},[_c('Header'),_c('div',{staticClass:"container main"},[_c('div',{staticClass:"beishu"}),_c('Parameter'),_c('Details'),_c('Step'),_vm._m(0)],1),_c('Footer')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn"},[_c('a',{attrs:{"href":"javascript:;"}},[_vm._v("返回")])])
}]

export { render, staticRenderFns }